import React, { useEffect, useState } from "react";
import "./SelectSongBook.scss";
import { IoCloseCircleOutline, IoSearchOutline } from "react-icons/io5";
import RestClient from "../../../@core/restClient";
import { Songbook } from "../../../@core/models";
import Spinner from "../UI/Spinner";

const SelectSongBook = (props: any) => {
  const [allBooks, setAllBooks]: any = useState([]);
  const [inputValue, setInputValue]: any = useState("");
  const [bookId, setBookId]: any = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectOpen, setSelectOpen] = useState(false);
  const [user] = useState(
    JSON.parse(localStorage.getItem("User") || "{}")?.id || ""
  );

  useEffect(() => {
    if (!selectOpen) {
      setInputValue(props.mainSongbook?.title || "");
    }
  }, [props.mainSongbook]);

  useEffect(function () {
    (async () => {
      try {
        const mybooks = await RestClient.getSongBooks(Number(user));
        const collbooks = await RestClient.getSongBooksCollaborators(
          Number(user)
        );
        const otherBooks = await RestClient.getSongbookList("");
        const combined = [...mybooks, ...collbooks, ...otherBooks];
        const unique = combined.filter(
          (book, index, self) =>
            self.findIndex((b) => b.id === book.id) === index
        );
        setAllBooks(unique);
      } catch (error) {
        console.log(error);
      }
    })();
    setIsLoading(false);
  }, []);

  const selectSongbook = (songbook: Songbook) => {
    setInputValue(songbook.title);
    setBookId(songbook.id);
    setSelectOpen(false);
  };

  useEffect(() => {
    if (bookId === null) return;
    props.passBookId(bookId);
  }, [bookId]);

  useEffect(() => {
    if (!props.isOpen) {
      setSelectOpen(false);
      setInputValue(props.mainSongbook?.title || "");
    }
  }, [props.isOpen]);

  const openBox = (e: any) => {
    e.stopPropagation();
    setInputValue("");
    setSelectOpen(true);
  };

  const closeBox = () => {
    setInputValue(props.mainSongbook?.title || "");
    setSelectOpen(false);
  };

  const normalize = (s: string) =>
    (s || "")
      .toLowerCase()
      .replace(/[^a-zа-яіїєґ0-9\s]/gi, "")
      .replace(/\s+/g, " ")
      .trim();

  return (
    <div className="select">
      {isLoading ? <Spinner /> : ""}
      <input
        className="select-input"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onClick={(e) => openBox(e)}
      />
      <IoSearchOutline className="select-search" />

      {selectOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 10
          }}
          onClick={closeBox}
        />
      )}

      <div
        className={`select-box ${selectOpen ? "visable" : ""}`}
        style={{ zIndex: 11 }}
      >
        <IoCloseCircleOutline className="select-close" onClick={closeBox} />
        {allBooks
          .filter((songbook: Songbook) =>
            normalize(songbook.title).includes(normalize(inputValue))
          )
          .map((songbook: Songbook) => (
            <div
              className="select-box-item"
              key={songbook.id}
              onClick={() => selectSongbook(songbook)}
            >
              {songbook.title}
            </div>
          ))}
      </div>
    </div>
  );
};

export default SelectSongBook;
